import type { TFunction } from 'i18next'

import {
    getMosquitoCategoryDisplayName,
    normalizeConfiguredDisplayCategory,
} from './mosquitoDisplay'

const SUMMARY_SEGMENT_PATTERN = /^(.+?)(\((\d+)\))$/

export const getDetectionClassDisplayName = (
    className: string | null | undefined,
    t: TFunction
): string => {
    const normalizedClassName = className?.trim()
    if (!normalizedClassName) {
        return '-'
    }

    const category = normalizeConfiguredDisplayCategory(normalizedClassName)
    if (!category) {
        return '-'
    }

    return getMosquitoCategoryDisplayName(category, t, 'detail.detectionClasses')
}

export const formatConfiguredDetectionClassSummary = (
    summary: string | null | undefined,
    t: TFunction
): string | null => {
    if (!summary) {
        return summary ?? null
    }

    const parts = summary
        .split(',')
        .map((part) => {
            const segment = part.trim()
            const match = segment.match(SUMMARY_SEGMENT_PATTERN)
            const rawLabel = match?.[1] ?? segment
            const count = Number(match?.[3] ?? '1')
            const category = normalizeConfiguredDisplayCategory(rawLabel)
            if (!category) {
                return null
            }
            const label = getMosquitoCategoryDisplayName(
                category,
                t,
                'detail.detectionClasses'
            )
            return `${label}(${Number.isFinite(count) ? count : 1})`
        })
        .filter((part): part is string => Boolean(part))

    return parts.length > 0 ? parts.join(', ') : null
}
